<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Downloads</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="downloads">Downloads</label>
                                    <select
                                        name="downloads[]"
                                        id="downloads"
                                        v-model="ordered"
                                        size="8"
                                        multiple
                                    >
                                        <option
                                            :value="index"
                                            v-for="(download, index) in downloads"
                                        >{{ download.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setDownloads">
                                    Ordenar Downloads
                                    <i class="fa fa-shopping-bag"></i>
                                </button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li
                                        v-for="(download,index) in selected"
                                        :key="download.id"
                                        class="list-group-item clearfix draggable"
                                    >
                                        <i class="mdi mdi-drag pull-left"></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span
                                            class="stages align-middle"
                                            :id="'stage' + download.id"
                                        >{{ index + 1 }}. {{ download.name }}</span>
                                        <button
                                            class="btn btn-danger pull-right"
                                            @click="remove(download, index)"
                                        >
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back">
                                    <i class="fa fa-arrow-left"></i> Voltar
                                </button>
                                <button
                                    class="btn btn-success"
                                    @click="save"
                                    style="margin-left:3px;"
                                >
                                    Salvar Ordenação
                                    <i class="fa fa-save"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import { postReorder } from "../../utils";

export default {
    data: function() {
        return {
            downloads: [],
            selected: [],
            ordered: [],
            order: false
        };
    },
    components: {
        draggable
    },
    methods: {
        getDownloadsArray: function(data) {
            let array = [];
            $.each(data, function(index, value) {
                if (value.sort_by) {
                    array.push(index);
                }
            });
            return array;
        },
        getDownloads: function() {
            let self = this;
            let api = self.$store.state.api + "download?paginated=false";
            let downloads = $("#downloads");

            self.$http
                .get(api)
                .then(response => {
                    self.downloads = response.data.data;
                    self.ordered = self.getDownloadsArray(self.downloads);
                })
                .then(() => {
                    downloads.bootstrapDualListbox();
                    downloads.ready(function() {
                        downloads.bootstrapDualListbox("refresh", true);
                    });
                })
                .catch(error => {
                    self.$message(
                        null,
                        "Ocorreu um erro ao buscar os Downloads",
                        "error"
                    );
                });
        },
        setDownloads: function() {
            const self = this;
            let downloads = self.selected;

            $("#downloads")
                .find(":selected")
                .each(function() {
                    downloads.push(self.downloads[$(this).val()]);
                });

            self.selected = downloads;
            self.order = true;
        },
        save: function() {
            const self = this;

            postReorder(self, self.selected, "sort/download", self.getDownloadsArray);
        },
        remove: function(download, index) {
            const self = this;
            const api = self.$store.state.api + "download/" + download.id;

            let array = [];
            $.each(self.selected, function(key, value) {
                if (index !== key) {
                    array.push(value);
                }
            });

            self.$http
                .put(api, {
                    sort_by: null
                })
                .then(response => {
                    this.selected = array;
                });
        },
        back: function() {
            window.location.reload();
        }
    },
    mounted: function() {
        this.getDownloads();
    }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DownloadOrder/Index.vue